export enum XpressVehicleType {
	None = 0,
	Moto = 1,
	Sedan = 2,
	SUV = 3,
	Fastest = 4,
	PetTaxi = 5,
	Courier = 6,
	Cargo = 7,
	Food = 8,
	Grocery = 9,
	ETrike = 10,
	Van = 11,
	Minibus = 12,
	Multicab = 13,
	EVCar = 14
}


export const getNewRideVehicleTypeInfo = (vt: XpressVehicleType, amount: number) => {
	const vehicle = vehicleTypes.find(i => i.xpressVehicleType == vt)!;
	// Important: do not mutate the shared `vehicleTypes` singleton objects.
	// Both ride and delivery flows request pricing and would overwrite each other.
	return { ...vehicle, price: amount };
};

/** Delivery (send parcel) flow: package + vehicle artwork; ride flow keeps SVGs. */
const DELIVERY_SEND_SERVICE_IMAGES: Partial<
	Record<XpressVehicleType, string>
> = {
	[XpressVehicleType.Moto]: '/images/service-icons/send_moto.png',
	[XpressVehicleType.Sedan]: '/images/service-icons/send_sedan.png',
	[XpressVehicleType.SUV]: '/images/service-icons/send_suv.png',
};

/** Copy for send-booking only; ride UI keeps `vehicleTypes[].serviceDescription`. */
const DELIVERY_SEND_SERVICE_DESCRIPTIONS: Partial<
	Record<XpressVehicleType, string>
> = {
	[XpressVehicleType.Moto]:
		'Best for small documents and light parcels—quick door-to-door.',
	[XpressVehicleType.Sedan]:
		'Standard parcel delivery; fits most everyday packages.',
	[XpressVehicleType.SUV]:
		'More room for larger or multiple parcels in one trip.',
	[XpressVehicleType.EVCar]:
		'Standard parcel delivery with a lower-emission vehicle.',
};

const DELIVERY_SEND_DEFAULT_DESCRIPTION =
	'Door-to-door parcel delivery to your recipient.';

export function getDeliverySendVehicleTypeInfo(
	vt: XpressVehicleType,
	amount: number,
): VehicleTypeFrontend {
	const base = getNewRideVehicleTypeInfo(vt, amount);
	const serviceDescription =
		DELIVERY_SEND_SERVICE_DESCRIPTIONS[vt] ??
		DELIVERY_SEND_DEFAULT_DESCRIPTION;
	const path = DELIVERY_SEND_SERVICE_IMAGES[vt];
	return {
		...base,
		serviceDescription,
		...(path ? { serviceImagePath: path } : {}),
	};
}

export interface VehicleTypeFrontend {
	xpressVehicleType: XpressVehicleType;
	imageLargePath: string,
	topViewPath: string,
	topViewMapHeadingCorrection?: number;
	topViewClass?: string,
	passengersNumber: number;
	serviceImagePath: string,
	serviceShortTitle: string;
	serviceTitle: string;
	serviceDescription: string;
	price?: number;
}

export const vehicleTypes: VehicleTypeFrontend[] = [
	{
		xpressVehicleType: XpressVehicleType.Moto,
		serviceImagePath: "/images/service-icons/moto.svg",
		passengersNumber: 1,
		serviceShortTitle: 'Moto',
		serviceTitle: 'Regular - Moto',
		serviceDescription: 'Affordable rides, all for yourself',
		imageLargePath: "/images/vehicle-types/large/moto.png",
		topViewPath: "/images/top-view/moto.svg",
		// Svgs provided in the figma are a bit misaligned, so need the custom shifts
		topViewClass: "-mt-[2px]",

		topViewMapHeadingCorrection: -90
	},

	{
		xpressVehicleType: XpressVehicleType.Sedan,
		imageLargePath: "/images/vehicle-types/large/regular-car.png",
		topViewPath: "/images/top-view/sedan.svg",
		topViewClass: "-mt-[1px]",
		passengersNumber: 4,
		serviceDescription: 'Affordable rides, all for yourself',
		serviceImagePath: "/images/service-icons/car.svg",
		serviceShortTitle: 'Car',
		serviceTitle: 'Regular - Car',
		topViewMapHeadingCorrection: -90
	}, {
		xpressVehicleType: XpressVehicleType.SUV,
		imageLargePath: "/images/vehicle-types/large/regular-suv.png",
		topViewPath: "/images/top-view/SUV.svg",
		topViewClass: "-mt-[1px]",
		passengersNumber: 5,
		serviceImagePath: "/images/service-icons/suv.svg",
		serviceShortTitle: 'SUV',
		serviceTitle: 'Regular - SUV',
		serviceDescription: 'Affordable ride for groups up to 5',
		topViewMapHeadingCorrection: -90
	},
	{
		xpressVehicleType: XpressVehicleType.EVCar,
		imageLargePath: "/images/vehicle-types/large/regular-car.png",
		topViewPath: "/images/top-view/sedan.svg",
		topViewClass: "-mt-[1px]",
		serviceImagePath: "/images/service-icons/suv.svg",
		passengersNumber: 5,
		serviceShortTitle: 'EVCar',
		serviceTitle: 'Regular - EVCar',
		serviceDescription: 'Affordable rides, all for yourself',
	},
];

export const getVehicleTypeInfo = (vt?: XpressVehicleType) => {
	return vehicleTypes.find(i => i.xpressVehicleType == vt);
}
